/**
 * The server-composed note that names a billed listing's combined-inventory role, under its name
 * in a billing table: "Lead listing: billed for every room in the building" on a lead listing, and
 * "Combined Inventory Add-On" on a following listing, whose monthly figure is that add-on
 * (docs/plans/2026-10-16-combined-inventory.md rule 5). The words arrive verbatim from the backend
 * (`billingLabel`, App::Billing::ListingCharge#label); this component only places them.
 *
 * Renders nothing for a hotel outside a combined inventory, so its row reads exactly as before.
 */
export default function BillingRoleNote({ label }: { label?: string | null }) {
  if (!label) return null

  return <span className="mt-0.5 block text-xs text-muted-foreground">{label}</span>
}
